import type { User } from '@/types/auth';

/** is_global_admin kan vara boolean, 1 eller '1' från API/DB. */
export function isGlobalAdminUser(user: User | null | undefined): boolean {
  if (!user) return false;
  const v = user.is_global_admin;
  return v === true || v === 1 || v === '1';
}
